import _ from 'lodash';

import CONSTANT from '../../constant';
import mElectronApi from '../../util/electron';
import History from '../../util/history';
import Mscratch from '../../services/mscratch';
import { loadExt } from '../../services/mscratch/ext';
import ExtensionAction from '../extension/action';
import ProjectAction from '../project/action';
import projectModel from '../../model/project.model';
import { message } from 'antd/lib/index';
import Emitter from '../../services/emitter';
import ProjectLocal from '../../services/project/project.local';
import Config from '../../config';

export default class ActionFs {

    constructor(store) {
        this.store = store;
    }

    savedFinishExec(type) {
        const store = this.store;
        const { project } = store.getState();
        const { file } = project;
        switch (type) {
            case 'open':
                Emitter.emit('OpenProject', file);
                break;
            case 'new':
                this.NewProject();
                break;
            case 'close':
                // mElectronApi.closeWindow();
                this.closeProject();
                break;
            case 'restart':
                mElectronApi.restart();
                break;
            case 'example':
                this.ReadedFile(null, {}, {
                    projectType: CONSTANT.PROJECT_TYPE.EXAMPLE
                });
                break;
            case 'list':
                History.replace('/list');
                break;
            default:
                break;
        }
        store.dispatch(ProjectAction.confirmType(null));
    }

    NewProject() {
        const store = this.store;
        const { extension } = store.getState();
        if (projectModel.isSaved()) {
            Mscratch.clear();
            const { devices } = extension;
            const codeyInfo = _.filter(devices, { id: 'codey' });
            if (!_.isEmpty(codeyInfo) && _.isArray(codeyInfo)) {
                loadExt(codeyInfo[0]);
            }
            History.push({
                pathname: '/'
            });
            projectModel.createNewProject();
        } else {
            if (History.location.pathname !== '/confirm/save/new') {
                History.push({
                    pathname: '/confirm/save/new'
                });
            }
        }
    }

    async OpenProject(file, projectInfo = {}) {
        const store = this.store;
        const { project, intlr } = store.getState();
        const { messages } = intlr;
        if (projectModel.isSaved()) {
            // 打开文件弹框默认配置
            const defaultShowDialogOptions = {
                title: messages['PROJECT.SHOW.DIALOG.TITLE'],
                filters: [
                    {
                        name: messages['PROJECT.DIALOG.FILTER.NAME'],
                        extensions: CONSTANT.PROJECT_SUFFIX
                    }
                ],
                properties: ['openFile']
            };
            try {
                const res = await Mscratch.import(file || project.file, defaultShowDialogOptions);
                if (res) {
                    projectInfo['filePath'] = res.filePath;
                    this.ReadedFile(null, res.data, projectInfo);
                    if (History.location.pathname !== '/') {
                        History.push({
                            pathname: '/'
                        });
                    }
                }
            } catch (error) {
                console.log(error);
            }
        } else {
            if (History.location.pathname !== '/confirm/save/open') {
                History.push({
                    pathname: '/confirm/save/open'
                });
            }
        }
    }

    async ReadedFile(err, data, projectInfo) {
        const store = this.store;
        const { messages } = store.getState().intlr;
        const successMsg = messages['IMPORT.SUCCESS.MSG'];
        const failMsg = messages['IMPORT.FAIL.MSG'];
        if (err) {
            let msg = [failMsg];
            if (_.isObject(err) && _.has(messages, err.key)) {
                msg = [messages[err.key], failMsg];
            } else {
                msg = [err, failMsg];
            }
            message.error(msg.join(' - '));
        } else {
            const success = () => {
                let projectType = projectInfo.hasOwnProperty('projectType') ? projectInfo.projectType : CONSTANT.PROJECT_TYPE.LOCAL;
                projectInfo['projectType'] = projectType;
                store.dispatch(ProjectAction.saved({
                    ...projectInfo,
                    saveStatus: '',
                    isLoaded: false
                }));

                if (projectType !== CONSTANT.PROJECT_TYPE.EXAMPLE) {
                    message.success(`${successMsg} `, 2);
                } else {
                    Mscratch.clearUpWorkspace();
                }
            };
            if (data) {
                try {
                    const exts = await Mscratch.renderProject(data, success);
                    if (exts.exts) {
                        ExtensionAction.load(exts.exts);
                    }
                } catch (error) {
                    console.warn(error);
                    Mscratch.clear();
                    message.error(failMsg);
                }
            }
        }
        store.dispatch(ProjectAction.file(null));
    }

    WritedFile(projectInfo) {
        const store = this.store;
        const { intlr } = store.getState();
        const { messages } = intlr;
        const successMsg = messages['EXPORT.SUCCESS.MSG'];

        message.success(successMsg, 2);
        store.dispatch(ProjectAction.saved({
            ...projectInfo,
            preProjectData: Mscratch.getProjectJsonString()
        }));
        ProjectAction.SaveMsg(store, CONSTANT.PROJECT_SAVE_STATUS.SUCCESS);
    }

    async SaveProject(isSaveas, projectInfo = {}) {
        const store = this.store;
        const { intlr, project } = store.getState();
        const { messages } = intlr;
        // 保存文件弹框默认配置项
        const defaultSaveDialogOptions = {
            title: messages['PROJECT.SAVE.DIALOG.TITLE'],
            defaultPath: `~/${messages['FILENAME.EMPTY']}.${CONSTANT.PROJECT_SUFFIX[0]}`,
            filters: [
                {
                    name: messages['PROJECT.DIALOG.FILTER.NAME'],
                    extensions: CONSTANT.PROJECT_SUFFIX
                }
            ]
        };
        let fpath;
        if (isSaveas) {
            fpath = '';
        } else if (_.has(projectInfo, 'filePath')) {
            fpath = projectInfo.filePath;
        } else if (_.has(project, 'filePath')) {
            fpath = project.filePath;
        } else {
            fpath = '';
        }
        try {
            const res = await Mscratch.export(fpath, defaultSaveDialogOptions);
            if (res) {
                projectInfo['filePath'] = res.filePath;
                this.WritedFile(projectInfo);
            }
        } catch (error) {
            ProjectAction.SaveMsg(store, CONSTANT.PROJECT_SAVE_STATUS.FAILURE);
            console.warn(error);
            throw new Error(error);
        }
    }

    async RenameProject(data, cb) {
        const store = this.store;
        const { name } = data;
        let { filePath } = store.getState().project;
        if (_.isNull(filePath)) {
            return console.log('file path is null');
        }
        let fileName = filePath.replace(/^.*[\\/]/, '');
        let newPath = filePath.replace(fileName, '');
        try {
            const res = await mElectronApi.rename(filePath, `${newPath}${name}.${CONSTANT.PROJECT_SUFFIX[0]}`);
            if (res) {
                store.dispatch(ProjectAction.rename({ filePath: res.filePath }));
                _.isFunction(cb) && cb();
            }
        } catch (err) {
            console.log('RenameProject error', err);
            _.isFunction(cb) && cb(err);
        }
    }

    async exportProject(data, cb) {
        try {
            const srcPath = Config.userProjectFilePath + '/' + data.localName + '.mblock';
            const descPath = await mElectronApi.saveDialog();
            if (descPath) {
                mElectronApi.copy(srcPath, descPath);
            }
            _.isFunction(cb) && cb();
        } catch (err) {
            _.isFunction(cb) && cb(err);
        }
    }

    copyFile(srcPath, descPath) {
        mElectronApi.copy(srcPath, descPath);
    }

    async closeProject() {
        const { project } = this.store.getState();
        const { projectType } = project;
        if (projectType !== CONSTANT.PROJECT_TYPE['LOCAL']) {
            await ProjectLocal.write(true);
        }
        mElectronApi.closeWindow();
    }

    async loadExample(data, name) {
        if (projectModel.isSaved()) {
            this.ReadedFile(null, data, {
                name,
                filePath: null,
                projectType: CONSTANT.PROJECT_TYPE.EXAMPLE
            });
        } else {
            if (History.location.pathname !== '/confirm/save/example') {
                History.push({
                    pathname: '/confirm/save/example'
                });
            }
        }
    }
}